'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:SignInCtrl
 * @description
 * # SignInCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('SignInCtrl', ['$scope', '$rootScope', '$window', '$state', 'GoogleApi', function ($scope, $rootScope, $window, $state, GoogleApi) {
    if($window.localStorage.googleToken && $rootScope.isAuthenticated === true) {
      $state.go('app.projects.list');
    }
    $scope.signIn = function() {
      GoogleApi.login();
    };
}]);
